module.exports = __webpack_public_path__ + "static/media/timeline-copy-1.0de8a818.png";